import { connect } from 'react-redux';
import UserMultiSelect from './UserMultiSelect';
import { removeInactiveUsers } from '../../helpers/UserUtils';

const mapStateToProps = state => ({
  users: removeInactiveUsers(state.users),
  identityId: state.identity.id
});

export default connect(mapStateToProps)(UserMultiSelect);
